export default {
  addOns: 'Дополнения',
  availability: 'Доступность',
  availabilityDaySelector: 'Выбор даты доступности',
  unavailable: 'Недоступно',
  person: 'человек',
  people: 'люди',
  reserveNow: 'Забронировать сейчас',
  selectTime: 'Выбрать время',
  select: 'Выбрать',
  reserve: 'Забронировать',
  time: 'Время',
  tier: 'Уровень',
  questions: 'Вопросы',
  addToCart: 'Добавить в корзину',
  checkout: 'Оформить заказ',
  total: 'Итого',
  whatsIncluded: 'Что включено',
  showMore: 'Показать больше',
  showLess: 'Показать меньше',
  session: 'Сессия',
  viewDetails: 'Просмотреть детали',
  findAvailability: 'Найти доступность',
  loading: 'Загрузка',
  capacity: 'Вместимость',
  noAvailableSessionsOnThisDate: 'Нет доступных сессий на эту дату',
  noGroupAvailableOnThisDateAndTime:
    'Нет {{groupTitle}} доступных на эту дату и время',
  noCollectionFound: 'Коллекция не найдена!',
  noResourceGroupFound: 'Группа ресурсов не найдена!',
  noData: 'Нет данных!',
  continue: 'Продолжить',
  night: 'ночь',
  nights: 'ночи',
  noAvailableSessionsForSelectedDates:
    'Некоторые даты в вашем выборе не имеют доступных сессий. Пожалуйста, выберите другие даты.',
  from: 'от',
  dateRangeSelector: 'Выбор диапазона дат',
  priceTierRadioGroup: 'Выбор уровня цены',
  startTime: 'Время начала',
  duration: 'Длительность',
  lengthOfStay: 'Длительность пребывания',
  startDate: 'Дата начала',
  endDate: 'Дата окончания',
  selectDates: 'Выберите даты',
  more: 'Ещё',
  selectStartTime: 'Выберите время начала',
  endTime: 'Время окончания',
  selectEndTime: 'Выберите время окончания',
  morning: 'Утро',
  afternoon: 'День',
  save: 'Сохранить',
  selectDuration: 'Выберите длительность',
  forLength: 'за {{length}}',
  moreDates: 'ещё {{count}}',
  addDate: 'Добавить дату',
  start: 'Начало',
  end: 'Окончание',
  pickupFrom: 'Получение с',
  returnBy: 'Возврат до',
  day: 'день',
  days: 'дней',
  hour: 'час',
  hours: 'часов',
};
